import { authenticatedPost } from './api_service';

const InquiryService = {
  requestReservation: (data) => {
    return authenticatedPost('/api/inquiries/', data);
  }
}

export default InquiryService;
